"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stats = [
    {
        type: 'attack',
        name: 'shotsTotal',
        performance: 'UP',
        bucketSteps: 1,
    },
    {
        type: 'attack',
        name: 'shotOnTarget',
        performance: 'UP',
        bucketSteps: 1,
    },
    {
        type: 'attack',
        name: 'keyPassTotal',
        performance: 'UP',
        bucketSteps: 1,
    },
    {
        type: 'attack',
        name: 'dribbleTotal',
        performance: 'UP',
        bucketSteps: 1.5,
    },
    {
        type: 'attack',
        name: 'dribbleWon',
        performance: 'UP',
        bucketSteps: 1.5,
    },
    {
        type: 'attack',
        name: 'foulGiven',
        performance: 'DOWN',
        bucketSteps: 1,
    },
    {
        type: 'attack',
        name: 'offsideGiven',
        performance: 'DOWN',
        bucketSteps: 1,
    },
    {
        type: 'attack',
        name: 'turnover',
        performance: 'DOWN',
        bucketSteps: 1,
    },
    {
        type: 'defence',
        name: 'foulCommitted',
        performance: 'DOWN',
        bucketSteps: 1,
    },
    {
        type: 'defence',
        name: 'tackleTotalAttempted',
        performance: 'UP',
        bucketSteps: 2,
    },
    {
        type: 'defence',
        name: 'tackleWon',
        performance: 'UP',
        bucketSteps: 1,
    },
    {
        type: 'defence',
        name: 'interceptionAll',
        performance: 'UP',
        bucketSteps: 1,
    },
    {
        type: 'defence',
        name: 'clearanceTotal',
        performance: 'UP',
        bucketSteps: 2,
    },
    {
        type: 'defence',
        name: 'shotBlocked',
        performance: 'UP',
        bucketSteps: 1,
    },
    {
        type: 'defence',
        name: 'offsideProvoked',
        performance: 'UP',
        bucketSteps: 1,
    },
    {
        type: 'passes',
        name: 'totalPasses',
        performance: 'UP',
        bucketSteps: 15,
    },
    {
        type: 'passes',
        name: 'passSuccessInMatch',
        performance: 'UP',
        bucketSteps: 10,
        suffix: '%',
    },
    {
        type: 'passes',
        name: 'passCrossTotal',
        performance: 'UP',
        bucketSteps: 2,
    },
    {
        type: 'passes',
        name: 'passCrossAccurate',
        performance: 'UP',
        bucketSteps: 1,
    },
    {
        type: 'passes',
        name: 'passLongBallTotal',
        performance: 'UP',
        bucketSteps: 5,
    },
    {
        type: 'passes',
        name: 'passLongBallAccurate',
        performance: 'UP',
        bucketSteps: 2,
    },
    {
        type: 'passes',
        name: 'passThroughBallTotal',
        performance: 'UP',
        bucketSteps: 1,
    },
    {
        type: 'passes',
        name: 'passThroughBallAccurate',
        performance: 'UP',
        bucketSteps: 1,
    },
];
exports.default = stats;
